import { AssetsDocument } from 'src/graphql/actions/asset/assets.query';
import { apolloClient as client } from 'src/graphql/client/apollo-client';

export const refetchAssets = () => {
  client.cache.evict({ fieldName: 'assets' });
  client.cache.gc();
  client.refetchQueries({
    include: [AssetsDocument],
  });
};
